/**
 * @module constants/Twitter
 */

export const TwitterErrors = Object.freeze({
  EMPTY_REQUEST_TOKEN_RESPONSE: 'Unable to authenticate with twitter - Empty Response',
  POPUP_BLOCKED: 'Twitter authentication blocked by popup blocker',
  MISSING_REQUEST_TOKEN:
    'Unable to authenticate with twitter - twitter failed to return a request token',
  MISSING_VERIFIER: 'Unable to authenticate with twitter - twitter failed to return a verifier',
  AUTH_DENIED: 'Unable to authenticate with twitter - authorization denied',
  UNABLE_TO_FETCH_ACCESS_TOKEN:
    'Unable to authenticate with twitter - unable to fetch access tokens',
} as const);

export const REQUEST_TOKEN_URL = 'https://api.twitter.com/oauth/request_token';
export const AUTHORIZE_URL = 'https://api.twitter.com/oauth/authorize';
export const ACCESS_TOKEN_URL = 'https://api.twitter.com/oauth/access_token';
export const UPDATE_STATUS_URL = 'https://api.twitter.com/1.1/statuses/update.json';
